import React from 'react';
import { useTranslation } from 'react-i18next';

import { Cell, Grid } from 'formlabs-web-components/Grid';
import { Button } from 'formlabs-web-components/Link';
import {
  ProgressTracker,
  StickyContainer
} from 'formlabs-web-components/Navigation';

import AddToCart from '../AddToCart';
import Price from '../Price';

import '../ProductDetailPlugin.module.css';

const OptionNavigation = ({
  step,
  mobile,
  steps,
  back,
  price,
  amount,
  sku,
  name,
  bundle,
  phoneNumberTracking,
  path,
  phoneNumberSales,
  emailAddressSales,
  convertPrinter,
  isBusinessHours,
  toggleCallUs
}) => {
  const [t] = useTranslation();
  const hasService =
    toggleCallUs &&
    bundle.get(toggleCallUs) &&
    bundle.get(toggleCallUs).size > 0;
  const lastOption = step + 1 === steps.length;
  const isCallUsStep = step === steps.length;
  return (
    <StickyContainer styleName="options-navigation">
      <Grid direction="x" hasContainer={true} gutters="margin">
        {!mobile && (
          <>
            <Cell mediumSize={8} contentAlignment="align-children-middle">
              <Button
                onClick={() => back(-1)}
                color="borderless-blue"
                arrow="left"
              >
                {t('Back')}
              </Button>
            </Cell>
            <Cell mediumSize={8}>
              <ProgressTracker
                currentStep={step}
                steps={steps}
                twoStep={true}
                back={back}
              />
            </Cell>
          </>
        )}
        <Cell
          mediumSize={8}
          smallSize={24}
          contentAlignment="align-children-middle"
        >
          <div styleName="total-and-continue">
            <div styleName="right">
              <span>{t('Total')}</span>
              <strong>
                <Price price={price} />
              </strong>
            </div>
            {!lastOption && !isCallUsStep && (
              <Button to={`/step${step + 1}/`} arrow="right">
                {t('Continue')}
              </Button>
            )}
            {lastOption && !toggleCallUs && path === '/' && (
              <AddToCart
                amount={amount}
                sku={sku}
                name={name}
                bundleOptions={bundle}
                onSuccess={convertPrinter}
              />
            )}
            {lastOption && toggleCallUs && !hasService && (
              <Button to={`/step${step + 1}/`} arrow="right">
                {t('Continue')}
              </Button>
            )}
            {lastOption && toggleCallUs && hasService && (
              <AddToCart
                amount={amount}
                sku={sku}
                name={name}
                bundleOptions={bundle}
                onSuccess={convertPrinter}
              />
            )}
            {isCallUsStep &&
              (isBusinessHours ? (
                <Button
                  color="dark"
                  onClick={phoneNumberTracking}
                  to={`tel:${phoneNumberSales}`}
                >
                  {t('Call {{phoneNumber}}', {
                    phoneNumber: phoneNumberSales
                  })}
                </Button>
              ) : (
                <Button
                  color="dark"
                  onClick={phoneNumberTracking}
                  to={`mailto:${emailAddressSales}`}
                >
                  {t('Email {{email}}', { email: emailAddressSales })}
                </Button>
              ))}
          </div>
        </Cell>
      </Grid>
    </StickyContainer>
  );
};
export default OptionNavigation;
